import { MesesPlanificacionHEDTO } from "components/Admin/Horas Extras/Planificacion Horas Extras/TypesPlanificacionUnidades"


export const unidadesEspeciales:number[] = [48,39,88]

export type DetallePlanificacionHE = {
    puedeRealizarAccion: boolean,
    anio: number,
    mes: number,
    nombreMes: string,
    diaMax: number,
    idPlanifUnidad: number,
    estadoPlanificacion: string,
    idSolReverso: number,
    refPlanifUnidad: string,
    fechaMaxima: Date,
    gruposActividad: DetalleGrupoActividadHEDTO[]
    listadoServidores: DetalleServidoresPlanificacionHE[]
    listadoServidoresOtrasUnidades: DetalleServidoresPlanificacionHE[]
    listadoRegimenLaboralesPlan: DetalleRegimenLaboralHEDTO[]
    listadoRegimenLaborales: RegimenLaboralHEDTO[]
    paramsHorasMesPlanificacionHE: ParamsHorasMesPlanificacionHEDTO[]
    novedadesServidores: NovedadesServidoresHEDTO[]
    detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[]
    informacionAprobador: InformacionAprobadorHEDTONovedad,
    nombreUnidadAprobacion: string
    //listadoServidoresPlanificacion: DetalleServidoresPlanificacion[]
}

export type PresupuestoPlanificacionHistoricoHEDTO = {
    anio: number,
    detalleRegimenPresupuestobyMes: HistorialPresupuestoPlanificacion[]
}

export type HistorialPresupuestoPlanificacion = {
    key: MesesPlanificacionHEDTO, // ANIO
    value: DetalleRegimenLaboralHEDTO
}

export type DetalleModificacionPlanificacionHE = {
    listadoServidores: DetalleServidoresPlanificacionHE[]
    listadoServidoresOtrasUnidades: DetalleServidoresPlanificacionHE[]
    detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[]
}

export type DetalleGrupoActividadHEDTO=
{
    idHeGrupoActividad: number
    nombreGrupo: string
    estado:string,
    usuario:string
}



export type DetalleServidoresPlanificacionHE = {
    contador: number,
    idpersona: number,
    idheplanifunidad: number,
    idheplanifpersonaunidad: number,
    idheplanifpersona: number,
    idcontratolaboral: number,
    tipo: string | null,
    identificacion: string,
    nombrescompletos: string
    cargo: string,
    rmu: string
    idregimenlaboral: number,
    nombreregimenlaboral: string,    
    siglasregimenlaboral: string,
    numactividades: number | null,
    horasextraordinarias: number | null,
    horassuplementarias: number | null,
    horastotales: number | null,
    valorhorasextraordinarias: number | null,
    valorhorassuplementarias: number | null,
    valortotal: number | null,
    estadoplanificacionunidad: string,    
    estadoplanificacionpersona: string,
    estadoplanificacionpersonaunidad: string,
    strestadoplanificacion: string,
    idestructuraorganica?:number|null,
    nombreestructuraorganica?:string,
    actividadesplanificadas: Array<{ key: number, value: ActividadesPlanificadas }>
}

export type DetalleRegimenLaboralHEDTO = {
    idRegimenLaboral: number,
    nombreRegimenLaboral: string,    
    siglasRegimenLaboral: string,
    presupuestoAsignado: number,
    presupuestoProyectado:number,
    presupuestoCodificado: number,
    reformaPresupuestaria: number,
    devengadoPagado: number,
    devengadoNoPagado: number,
    planificadoActual: number,
    presupuestoDevengar: number,
    presupuesotDevengadoMensual?: number,
    presupuestoDevengadoAdicional?: number,
    planificacionMesAnterior?:number
}

export type RegimenLaboralHEDTO = {
    idRegimenLaboral: number,
    nombreRegimenLaboral: string,    
    siglasRegimenLaboral: string,
    siglasLetrasRegimenLaboral:string
}


export type ActivadesRegimenHEDTO = {
    idActividad: number,
    idRegimen: number,
    idGrupo: number,
    nombreActividad: string,    
    estado: string
}

export type ParamsHorasMesPlanificacionHEDTO = {
    idheparamhorasmes: number,
    idregimenlaboral: number,
    horasExtraordinarias: number,
    horasSuplementarias: number,
    horasExtraySuple: number
}

export type NovedadesServidoresHEDTO = 
{
    idPersona: number,
    tipoNovedad: string,
    fechaDesde: Date,
    fechaHasta: Date,
    numDias: number,
    descripcionNovedad:string
}

export type DataActividadSave = {
    regimenLaboralSeleccionado: number,
    actividadSeleccionada: number,
    horasSuplementarias: number | undefined,
    horasExtraordinarias: number | undefined,
    observacion: string,
    servidoresSeleccionados: Array<{ key: number, value: ServidorSeleccionado }>,
    grupoSeleccionado?:number
}

export type ServidorSeleccionado = {
    idpersona: number,
    identificacion: string,
    nombrecompleto: string,
    cargo: string,
    siglasregimen: string,
    rmu: number,
    idregimen: number,
    horasExtraordinarias: number | undefined,
    horasSuplementarias: number | undefined,
    observacion?:string
}

export type DetalleActividadPlanHEDTO = {
    idregimenLaboral: number
    nombreregimenLaboral: string,
    idactividad : number,
    nombreactividad: string,
    horasSuplementarias: number | undefined,
    valorhorasSuplementarias: number | undefined,
    horasExtraordinarias: number | undefined,
    valorhorasExtraordinarias: number | undefined,
    valortotal: number | undefined,
    observacion: string,
    idgrupoactividad:number,
    servidoresPlanificados: Array<{ key: number, value: ServidorPlanificado }>
}

export type ServidorPlanificado = {
    idpersona: number,
    idestructura: number,
    identificacion: string,
    nombrecompleto: string,
    cargo: string,
    siglasregimen: string,
    rmu: number,
    idregimen: number,
    horasExtraordinarias: number | undefined,
    horasSuplementarias: number | undefined,
    valorhorasExtraordinarias: number | undefined,
    valorhorasSuplementarias: number | undefined
    valortotal: number | undefined
}

export type ActividadPlanbyServidorHEDTO =
{
    idregimenLaboral: number
    idactividad: number
    nombreactividad: string,
    observacion: string
}

export type DetalleServidoresPlanificacion = {
    idpersona: number,
    idheplanifunidad: number,
    idcontratolaboral: number,
    tipo: string | null,
    identificacion: string,
    nombrescompletos: string
    cargo: string,
    rmu: string
    idregimenlaboral: number,
    nombreregimenlaboral: string,    
    siglasregimenlaboral: string,
    numactividades: number | null,
    horasextraordinarias: number | null,
    horassuplementarias: number | null,
    valorhorasextraordinarias: number | null,
    valorhorassuplementarias: number | null,
    valortotal: number | null,
    estado: string,    
    estadoplanificacion: string,
    actividadesplanificadas: Array<{ key: number, value: ActividadesPlanificadas }>
}

export type ActividadesPlanificadas =
{
    idActividad: number,
    idActividadPersona: number,
    nombreActividad: string,
    horasSuplementarias: number | undefined,
    horasExtraordinarias: number | undefined,
    observacion: string,
    idEstructura: number,
    nombreEstructura: string,
    idGrupo?: number
}


export type DetalleServidorPlanHEDTO = {
    idregimenLaboral: number
    idpersona: number,
    rmu : string,
    actividades: ActividadesPlanificadas[],
}

export type InformacionAprobadorHEDTONovedad = {
    informacionAprobador: InformacionAprobadoresHEDTO, 
    mensaje: string
}

export type InformacionAprobadoresHEDTO = {
    nombres: string,
    apellidos: string,
    email: string,
    idpersona: number,
    tipoAprobador: number,
    TipoAprobadorString: string,
    idEstructuraOrganica: number,
    idEstructuraOrganicaAprobacion: number,
}

export type SolicitudReversoDTO  = {
    Observacion:string
}